import React, { FC } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import type { ReduxState } from 'app/redux/types';

import { Icon } from 'app/design-system/components/Icon';
import { StakeType } from 'app/lib/staking/constants';
import { selectAnyHasLockedState, selectSomeHasError } from 'app/modules/BetSlip/selectors/entries';

import { selectCurrentStakeType } from '../../../../selectors/stakeTypes';

import styles from './SelectedPaymentOption.module.scss';

// ---

type StoreProps = {
  disabled: boolean;
  isExpress: boolean;
};

type SelectedPaymentOptionProps = {
  label: string | JSX.Element;
  onClick: () => void;
};

const SelectedPaymentOption: FC<SelectedPaymentOptionProps & StoreProps> = ({
  label,
  onClick,
  isExpress,
  disabled,
}) => {
  return (
    <div className={classNames(styles.selectedPaymentOption, {
      [styles.amountSpace]: isExpress,
    })}
         data-test="selectedPaymentOption-container">
      {label}
      <button type="button"
              disabled={disabled}
              data-test="selectedPaymentOption-removeButton"
              className={styles.removeSelectedPaymentOption}
              onClick={onClick}>
        <Icon icon="cross"
              data-test="selectedPaymentOption-removeIcon"
              size={7} />
      </button>
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => ({
  disabled: selectSomeHasError(state) || selectAnyHasLockedState(state),
  isExpress: selectCurrentStakeType(state).has(StakeType.EXPRESS),
});

export default connect(mapStateToProps)(SelectedPaymentOption);
